import { ReactNode } from 'react'

export const Popup = ({ children }: { children: ReactNode }) => {
  return (
    <div className="fixed top-1/2 left-4 sm:left-1/2 right-4 sm:right-[unset] sm:-translate-x-1/2 -translate-y-1/2 shadow-dialog rounded-2xl sm:min-w-[400px]">
      {children}
    </div>
  )
}
